/* Clérolis - header behavior: sticky, transparent-over-hero, dropdown a11y. */
if (!customElements.get('clerolis-header')) {
  customElements.define(
    'clerolis-header',
    class ClerolisHeader extends HTMLElement {
      connectedCallback() {
        this.sticky = this.dataset.sticky;
        this.transparent = this.dataset.transparent === 'true';
        this.main = document.getElementById('MainContent');

        this.setupTransparent();
        this.setupScrollState();
        this.setupHideOnScroll();
        this.setupDropdowns();
      }

      get headerHeight() {
        return this.offsetHeight || 0;
      }

      /* Publish the exact header height to a CSS var so the transparent overlay
         offset (applied in the section's inline <style> at first paint) is correct.
         A ResizeObserver keeps it in sync with anything that changes the header's
         height after first paint (logo image load, font swap, text wrapping) —
         a stale value shows up as a white gap under the announcement bar. */
      setupTransparent() {
        if (!this.transparent) return;
        const apply = () => document.documentElement.style.setProperty('--clerolis-header-h', this.headerHeight + 'px');
        apply();
        window.addEventListener('resize', apply);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(apply);
        if ('ResizeObserver' in window) new ResizeObserver(apply).observe(this);
      }

      setupScrollState() {
        // Solid the moment the page is no longer at the very top — on every
        // page, transparent-over-hero included — and always while the mobile
        // drawer is open (a transparent bar over the hero looks broken there).
        const drawer = this.querySelector('#Details-menu-drawer-container');
        const update = () => {
          const drawerOpen = drawer ? drawer.hasAttribute('open') : false;
          this.classList.toggle('is-solid', drawerOpen || window.scrollY > 8);
        };
        update();
        window.addEventListener('scroll', update, { passive: true });
        if (drawer) drawer.addEventListener('toggle', update);
      }

      setupHideOnScroll() {
        if (this.sticky !== 'on-scroll-up') return;
        let lastY = window.scrollY;
        window.addEventListener(
          'scroll',
          () => {
            const y = window.scrollY;
            if (y > lastY && y > this.headerHeight * 2) this.classList.add('clerolis-header--hidden');
            else this.classList.remove('clerolis-header--hidden');
            lastY = y;
          },
          { passive: true }
        );
      }

      setupDropdowns() {
        const items = this.querySelectorAll('.clerolis-nav__item--has-panel');
        const coarse = window.matchMedia('(hover: none)').matches;
        items.forEach((item) => {
          const trigger = item.querySelector('[data-nav-trigger]');
          const expand = (v) => trigger && trigger.setAttribute('aria-expanded', v ? 'true' : 'false');
          item.addEventListener('mouseenter', () => expand(true));
          item.addEventListener('mouseleave', () => {
            expand(false);
            item.classList.remove('is-open');
          });
          item.addEventListener('focusin', () => expand(true));
          item.addEventListener('focusout', (e) => {
            if (!item.contains(e.relatedTarget)) {
              expand(false);
              item.classList.remove('is-open');
            }
          });
          if (coarse && trigger) {
            trigger.addEventListener('click', (e) => {
              if (!item.classList.contains('is-open')) {
                e.preventDefault();
                items.forEach((o) => o !== item && o.classList.remove('is-open'));
                item.classList.add('is-open');
                expand(true);
              }
            });
          }
        });
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') items.forEach((o) => o.classList.remove('is-open'));
        });
        document.addEventListener('click', (e) => {
          if (!e.target.closest('.clerolis-nav__item--has-panel')) {
            items.forEach((o) => o.classList.remove('is-open'));
          }
        });
      }

    }
  );
}
